import React, { Component } from "react";
import { Input, DatePicker } from "antd";
import { Dropdown } from "../../../../components/common/dropdown";
import { apiVehicle } from "../../../../api/api-vehicle";
import { emitter } from "../../../../common/utils/emitter";
import moment from "moment";

export class TableSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account_name: "",
      employee_id: "",
      branches: [
        { id: -1, code: "all", name: "Tất cả" },
        { id: 1, code: "HN", name: "HN" },
        { id: 2, code: "ĐN", name: "ĐN" },
        { id: 3, code: "HCM", name: "HCM" },
      ],
      roles: [
        { id: -1, code: "all", name: "Tất cả" },
        { id: 1, code: 1, name: "Admin" },
        { id: 2, code: 2, name: "Sale" },
      ],
      departments: [
        { id: -1, code: "all", name: "Tất cả" },
        { id: 1, code: 1, name: "Admin điều hành" },
        { id: 2, code: 2, name: "Điều hành khối" },
        { id: 3, code: 3, name: "Kế toán" },
      ],
      accounts_status: [
        { id: -1, code: "all", name: "Tất cả" },
        { id: 1, code: 1, name: "Active" },
        { id: 2, code: 2, name: "Inactive" },
      ],
      created_person: "",
      created_date: "",
      checkSearch: false,
      branch: null,
      account_status: null,
      department: null,
      role: null,
    };
    //this.branchs = [];
  }

  componentWillReceiveProps(newProps) {
    if (newProps.has_driver !== this.props.has_driver) {
      this.dropdown.setState({
        title: "Trạng thái",
        titleColor: "colorTitleFirst",
      });
      this.setState({ status: null });
    }
  }

  async componentDidMount() {}

  // setOptionState = () => {
  //     if (!this.dataOptions) {
  //         return;
  //     }
  //     const { status, supplier_groups } = this.dataOptions;

  //     supplier_groups.unshift({ id: -1, code: 'all', name: 'Tất cả' });
  //     status.unshift({ value: -1, name: 'Tất cả' });
  //     this.setState({
  //         car_resource: supplier_groups,
  //         car_status: status.map(item => { return { ...item, code: item.value } }),
  //         checkSearch: false
  //     })
  // }

  onChangeText = (feild, value) => {
    this.setState({ [feild]: value, checkSearch: false });
  };

  search = (event) => {
    if (event.keyCode === 13) {
      this.submitSearch();
      event.preventDefault();
    }
  };

  submitSearch = async () => {
    await this.setState({
      checkSearch: true,
    });
    this.props.search(1);
  };

  setStatus = (value) => {
    if (value.id == -1) {
      this.setState({ account_status: null, checkSearch: false });
    } else {
      this.setState({ account_status: value.id, checkSearch: false });
    }
  };

  setBranch = (value) => {
    if (value.id == -1) {
      this.setState({ branch: null, checkSearch: false });
    } else {
      this.setState({ branch: value.code, checkSearch: false });
    }
  };

  setDepartment = (value) => {
    if (value.id == -1) {
      this.setState({ department: null, checkSearch: false });
    } else {
      this.setState({ department: value.id, checkSearch: false });
    }
  };

  createdDate = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      created_date: unixNew * 1000,
      checkSearch: false,
    });
  };

  setRole = (value) => {
    if (value.id == -1) {
      this.setState({ role: null, checkSearch: false });
    } else {
      this.setState({ role: value.code, checkSearch: false });
    }
  };
  render() {
    const {
      account_name,
      accounts_status,
      departments,
      branches,
      created_date,
      created_person,
      employee_id,
      roles,
    } = this.state;
    return (
      <div className="search-bar">
        <div className="search-user-account-container">
          <div className="search-contract">
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("account_name", param.target.value)
              }
              value={account_name}
              placeholder="Tên tài khoản"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("employee_id", param.target.value)
              }
              value={employee_id}
              placeholder="Mã NV"
              className="input"
            />
            <Dropdown
              select={(value) => this.setBranch(value)}
              className="input"
              menu={branches}
              title="Khu vực"
            />
            <Dropdown
              select={(value) => this.setRole(value)}
              className="input"
              menu={roles}
              title="Vai trò"
            />
          </div>
          <div className="search-contract">
            <Dropdown
              select={(value) => this.setDepartment(value)}
              className="input"
              menu={departments}
              title="Bộ phận"
            />
            <Dropdown
              select={(value) => this.setStatus(value)}
              className="input"
              menu={accounts_status}
              title="Trạng thái"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("created_person", param.target.value)
              }
              value={created_person}
              placeholder="Người tạo"
              className="input"
            />
            <DatePicker
              // inputReadOnly
              dropdownClassName="date-picker-dropdown-bottom"
              getPopupContainer={(node) => {
                if (node) {
                  return node.parentNode;
                }
                return document.body;
              }}
              className="input"
              onChange={this.createdDate}
              placeholder="Ngày tạo"
              format="DD/MM/YYYY"
              disabledDate={(currentDate) => {
                const currentTimes = currentDate.valueOf();
                const nowTimes = moment().endOf("day").valueOf();
                return currentTimes >= nowTimes;
              }}
            />
          </div>
        </div>
        <div onClick={this.submitSearch} className="btn-success">
          <img
            alt=""
            onClick={this.submitSearch}
            style={{ objectFit: "contain", cursor: "pointer", marginRight: 5 }}
            width={16}
            src={require("../../../../assets/icons/search-solid-white.png")}
          />
          Search
        </div>
      </div>
    );
  }
}
